module.exports = __webpack_public_path__ + "static/img/LOGO VERSIÓN FINAL NQA.acd41f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/LOGO VERSIÓN FINAL NQA.png
// module id = 9X8J
// module chunks = 1